import axios from "axios";

export const axioscrmInstance = axios.create({
  baseURL: " https://live.api.bigfivecrm.com",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    AuthToken: `Bearer b25ib2FyZGluZ2FwaUBiaWdmaXZlY3JtLmNvbTpzZXJpb3VzMjNhJCMkRkQqI0ZBT1NJREYjKCkqI1dIRkEpKFJVKSgjUUpGU0E=`,
  },
});

const DOMAIN_BASE_URL = "https://onboarding.customers.bigfivecrm.com/";
const ONBOARDING_CREATE_API = "api/v2/auth/onboarding";
const CHECKOUT_API = "api/v2/auth/onboarding/checkout";
const ONBOARDING_GET_API = "api/v2/auth/onboarding/view/deal";
const OTP_VERIFY_API="api/v2/auth/onboarding/verify";



export const OtpVerifyApi = async (data) => {
  try {
    const response = await axioscrmInstance.post(OTP_VERIFY_API, data);
    return response.data;
  } catch (error) {
    console.error("Register failed:", error);
    throw error;
  }
};


export const DomainLoginApi = async () => {
    try {
      
        const response = await axios.post(`${DOMAIN_BASE_URL}login`);

        console.log("Response from API:", response.data);
        return response.data;
    } catch (error) {
        console.error("Error Login domain:", error.response?.data || error.message);
    }
};

export const DomainCheckApi = async (sld, tld) => {
    try {
      
        const response = await axios.post(`${DOMAIN_BASE_URL}domain/check`, {
            // headers: {Authorization: `Bearer ${token}`} ,
            params: { sld, tld }  // Correct way to pass query parameters in a GET request
        });

        console.log("Response from API:", response.data);
        return response.data;
    } catch (error) {
        console.error("Error checking domain:", error.response?.data || error.message);
    }
};

export const DomainPricingApi = async (format,username) => {
  try {
    
      const response = await axios.post(`${DOMAIN_BASE_URL}reseller/pricing`, {
          // headers: {Authorization: `Bearer ${token}`} ,
          params: { format, username }  // Correct way to pass query parameters in a GET request
      });

      console.log("Response from API:", response.data);
      return response.data;
  } catch (error) {
      console.error("Error checking domain:", error.response?.data || error.message);
  }
};


export const DomainCreateApi = async (sld, tld,
  period,
  registrantName,
  registrantEmail,
  registrantCountry,
  registrantProvince,
  registrantContactNumber,
  registrantPostalCode,
  registrantAddress1,
  registrantCity,
  ns1, 
  ns2 
) => {
  try{
    const response = await axios.post(`${DOMAIN_BASE_URL}domain`, { sld, tld, period,
      registrantName,
      registrantEmail,
      registrantCountry,
      registrantProvince,
      registrantContactNumber,
      registrantPostalCode,
      registrantAddress1,
      registrantCity,
      ns1,
      ns2
     });
    return response.data;
  }catch(error){
    console.error("Error creating domain:", error.response?.data || error.message);
  }
}


// ==== CREATE LEADS=====
export const onboardingCreateApi = async (data) => {
  try {
    const response = await axioscrmInstance.post(ONBOARDING_CREATE_API, data);
    return response.data;
  } catch (error) {
    console.error("Register failed:", error);
    throw error;
  }
};

// === CheckoutAPI====
export const checkOutApi = async (data) => {
  try {
    const response = await axioscrmInstance.post(CHECKOUT_API, data);
    return response.data;
  } catch (error) {
    console.error("Register failed:", error);
    throw error;
  }
};

// === ONBOARDING GET API====
export const onboardingGetApi = async (data) => {
  try {
    const response = await axioscrmInstance.post(ONBOARDING_GET_API, data);
    return response.data;
  } catch (error) {
    console.error("Register failed:", error);
    throw error;
  }
};
